<template>
  <v-card class="pa-6">
    <div class="d-flex align-center">
      <v-spacer></v-spacer>
      <h2 class="ml-12">{{ isEditing ? 'Atualizar' : 'Nova' }} métrica</h2>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-divider class="mt-2 mb-3"></v-divider>

    <v-form ref="form">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <label>Métrica</label>
          <v-autocomplete
            v-model="metric.metricId"
            hide-details="auto"
            :disabled="loading"
            :items="calibMetrics"
            item-value="id"
            item-text="name"
            append-icon="mdi-chevron-down"
            placeholder="Selecione a métrica"
            outlined
            class="primary-input"
          >
            <template v-slot:item="{ item }">
              <span class="text-caption" v-if="!item.name.includes('(')">
                {{ item.name }} ({{ item.unit }})
              </span>
              <span class="text-caption" v-else>
                {{ item.name }}
              </span>
            </template>
            <template v-slot:selection="{ item }">
              <span class="text-caption" v-if="!item.name.includes('(')">
                {{ item.name }} ({{ item.unit }})
              </span>
              <span class="text-caption" v-else>
                {{ item.name }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12">
          <label>Resolução</label>
          <v-text-field
            type="number"
            v-model="metric.resolution"
            hide-details="auto"
            :disabled="loading"
            placeholder="Digite a resolução"
            outlined
            class="primary-input"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex px-1 mt-3">
      <v-spacer></v-spacer>
      <v-btn
        class="primary-button mr-0"
        depressed
        :loading="loading"
        @click="submit"
      >
        {{ isEditing ? 'Atualizar' : 'Adicionar' }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'

export default {
  name: 'ManageMetric',

  props: {
    metricId: {},
    patternId: String,
  },

  data() {
    return {
      loading: false,
      metric: {},
      calibMetrics: [],
      isEditing: false,
      apiService: new ApiService(),
    }
  },

  created() {
    this.getMetrics()

    if (this.metricId) {
      this.isEditing = true
      this.getSelectedMetric()
    }
  },

  methods: {
    getSelectedMetric() {
      this.apiService
        .get('calibration/v2/pattern/metric/' + this.metricId)
        .then((response) => {
          this.metric = response.content
        })
    },

    getMetrics() {
      this.apiService.get('calibration/v2/metric/list').then((response) => {
        this.calibMetrics = response.content
      })
    },

    submit() {
      if (!this.$refs.form.validate()) return

      this.metric.resolution = this.metric.resolution
        .toString()
        .replace(',', '.')

      if (this.isEditing) this.edit()
      else this.add()
    },

    add() {
      this.loading = true

      this.metric.patternId = this.patternId

      this.apiService
        .post('calibration/v2/pattern/metric', this.metric)
        .then(() => {
          this.$toast.success('Métrica adicionada com sucesso!')
          this.loading = false
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true

      this.metric.patternId = this.patternId

      this.apiService
        .put('calibration/v2/pattern/metric', this.metric)
        .then(() => {
          this.$toast.success('Métrica adicionada com sucesso!')
          this.loading = false
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style></style>
